import { render } from "./TestPage.vue?vue&type=template&id=11b1f8ad&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=11b1f8ad&lang=css"
import "./TestPage.vue?vue&type=style&index=1&id=11b1f8ad&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b1f8ad"]])

export default __exports__